export enum ValidateScenario {
    onSend,
    onCloseDraft,
}
